<template>
    <div class="brand-page">
        <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
            <van-list
                v-model="loading"
                :finished="finished"
                finished-text="没有更多了"
                @load="onLoad"
            >
                <van-row :gutter="12">
                    <van-col :span="12" v-for="item in list" :key="item.id">
                        <div class="brand-wrapper" @click="goShopList(item.id)">
                            <img
                                style="width: 100%"
                                :src="`https://wowoto.oss-cn-shanghai.aliyuncs.com/pinboo/${item.images}`"
                            />
                            <p>{{ item.name }}</p>
                        </div>
                    </van-col>
                </van-row>
            </van-list>
        </van-pull-refresh>
    </div>
</template>
<script>
import { fetchBrandsSelectionBox } from "../../services/instant";
import Cookies from "js-cookie";

export default {
    data() {
        return {
            brands: [],
            params: {
                current: 1,
                size: 10,
            },
            list: [],
            loading: false,
            finished: true,
            refreshing: false,
            total: 0,
        };
    },
    mounted() {
        const token = Cookies.get("token");
        if (token) {
            this.finished = false;
            // this.onLoad()
        } else {
            this.goLogin();
        }
    },
    methods: {
        goLogin() {
            const toPath = "/brandList";
            this.$router.push(`/login?redirect=${toPath}`);
        },
        onLoad() {
            setTimeout(() => {
                if (this.refreshing) {
                    this.list = [];
                    this.params.current = 1;
                    this.refreshing = false;
                }
                fetchBrandsSelectionBox(this.params)
                    .then((res) => {
                        this.list = this.list.concat(res.data.records);
                        // this.total = res.data.total
                        this.params.current++;
                        this.loading = false;
                        if (this.list.length >= res.data.total) {
                            this.finished = true;
                        }
                    })
                    .catch((err) => {
                        console.log(err);
                        // 登录超时的话，清除已有token,重新登录
                        if (err.code === 1001) {
                            Cookies.remove("token");
                            Cookies.remove("secretKey");
                            this.goLogin();
                        }
                    });
            }, 0);
        },
        onRefresh() {
            // 清空列表数据
            this.finished = false;
            // 重新加载数据
            // 将 loading 设置为 true，表示处于加载状态
            this.loading = true;
            this.onLoad();
        },
        onSearch() {
            this.list = [];
            this.params.current = 1;
            this.onLoad();
        },
        async getBrands() {
            this.brands = await fetchBrandsSelectionBox();
        },
        goShopList(brandId) {
            this.$router.push({
                path: "/shopList",
                query: { brandId },
            });
        },
    },
};
</script>
<style lang="less" scoped>
.brand-page {
    padding: 10px;
    //background: #D3D3D3;
    .brand-wrapper {
        position: relative;
        margin-bottom: 10px;
        border-radius: 5px;
        img {
            border-radius: 10px;
            box-shadow: 0px 2px 20px 0px rgba(0, 0, 0, 0.1);
        }
        p {
            box-sizing: border-box;
            position: absolute;
            line-height: 30px;
            background: rgba(255, 255, 255, 0.9);
            box-shadow: 0px 5px 10px 0px rgba(0, 0, 0, 0.1);
            border-radius: 4px;
            opacity: 0.49;
            font-size: 16px;
            font-weight: 500;
            color: #000000;
            width: 100%;
            bottom: 1.026vw;
            margin: 0;
            padding-left: 10px;
        }
    }
}
</style>
